import React, { memo } from 'react'
import { duration, Fade } from '@mui/material'
import PropTypes from 'prop-types'
import PageTemplateData from '@v4/utils/data/PageTemplateData'
import PDFBackgroundImage from '@v4/components/common/PDFBackroundImage'
import Fallback from '@v4/components/common/WithLazy/components/Fallback'
import AppThemeProvider from '@v4/components/common/AppThemeProvider'
import { usePDFContainer } from './PDFContainer.hooks'

const PDFContainer = props => {
	const [
		{ classes, collection, showBorders, contentTheme, withBgImage, bgImage, bgShading, children, visible, ref },
	] = usePDFContainer(props)

	switch (collection) {
		case PageTemplateData.SORT_GROUPS.MAIN:
			return (
				<div className={classes.root} ref={ref}>
					{visible ? (
						<>
							<Fade
								in={showBorders}
								unmountOnExit
								timeout={{
									enter: 0,
									exit: duration.standard,
								}}
							>
								<div className={classes.topBorder} />
							</Fade>
							<Fade in={showBorders} unmountOnExit>
								<div className={classes.bottomBorder} />
							</Fade>
							<div className={classes.content}>
								<AppThemeProvider theme={contentTheme}>
									{withBgImage && <PDFBackgroundImage image={bgImage} shading={bgShading} />}
									{children}
								</AppThemeProvider>
							</div>
						</>
					) : (
						<>
							<div className={classes.content}>
								<Fallback />
							</div>
						</>
					)}
				</div>
			)
		default:
			return children || null
	}
}

PDFContainer.propTypes = {
	collection: PropTypes.string.isRequired,
	active: PropTypes.bool,
	children: PropTypes.node,
}

export default memo(PDFContainer)
